module.exports = {"pathContext":{"relativePath":"GDK>src/pages/sales.js"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/contactus.json
// module id = 312
// module chunks = 219723240421529